import { Book, Description } from '@mui/icons-material';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import DetailHeader from '../components/DetailHeader';
import { helpSections } from '../help/articles';
import usePageTitle from '../hooks/usePageTitle';

export default function HelpPage() {
  const { t } = useTranslation(['pages', 'common']);
  usePageTitle(t('pages:help.title'));

  return (
    <Stack spacing={3}>
      <DetailHeader
        title={t('pages:help.title')}
        subtitle={t('pages:help.subtitle')}
        sectionIcon={<Book color="primary" />}
        breadcrumbs={[{ label: t('pages:help.title') }]}
      />

      <Stack spacing={2}>
        {helpSections.map((section) => (
          <Card key={section.slug}>
            <CardContent>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                alignItems={{ xs: 'flex-start', md: 'center' }}
                justifyContent="space-between"
              >
                <Stack spacing={0.5}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Description color="primary" />
                    <Typography variant="h6">{t(section.titleKey)}</Typography>
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {t(section.descriptionKey)}
                  </Typography>
                </Stack>
                <Button component={RouterLink} to={`/help/${section.defaultArticleSlug}`} variant="contained">
                  {t('pages:help.actions.openArticle')}
                </Button>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
}
